export const GUIDE_STEPS = [
  {
    id: 'energy',
    title: 'Pick the energy',
    text: 'Every song starts with a feel. Pick the one that sounds like your mood today.',
  },
  {
    id: 'beat',
    title: 'Get a beat going.',
    text: "Pick a sound pack and hit play. Let it loop. You're going to write to this.",
  },
  {
    id: 'flow',
    title: 'Find your flow.',
    text: "Before words, find the rhythm. Hum or say 'da da da' along with the beat for two bars. "
      + "Where your voice lands is your flow. Don't think about words yet.",
  },
  {
    id: 'hook',
    title: 'Write the hook.',
    text: 'The hook is the part people remember and sing back. 2 to 4 short lines. '
      + 'Say the main idea of your song in the simplest way.',
    tip: 'Make line 2 rhyme with line 1. Tap the magnifier on line 1 for rhymes.',
  },
  {
    id: 'verse',
    title: 'Write a verse.',
    text: 'The verse tells the story behind the hook. 4 lines to start. One line per bar. '
      + 'Real details beat big words.',
  },
  {
    id: 'finish',
    title: 'You wrote a song.',
    text: '',
  },
];

export const filledLines = (section) => (
  (section?.lines || []).filter((line) => String(line?.text || '').trim()).length
);

const SECTION_ORDER = ['Intro', 'Hook', 'Verse 1', 'Verse 2', 'Verse 3', 'Bridge', 'Outro'];

// Milestones live on the saved song, so a reload mid-guide never locks the Next button.
export const stepComplete = (song, step, { beatPlayed = false, flowConfirmed = false } = {}) => {
  if (step === 0) return Boolean(song?.vibe);
  if (step === 1) return Boolean(beatPlayed || song?.guide?.beatPlayed);
  if (step === 2) return Boolean(flowConfirmed || song?.guide?.flowConfirmed);
  if (step === 3) {
    return filledLines(song?.sections?.find((section) => section.label === 'Hook')) >= 2;
  }
  if (step === 4) {
    return filledLines(song?.sections?.find((section) => section.label === 'Verse 1')) >= 4;
  }
  return step === 5;
};

const withGuideStep = (song, step) => ({
  ...song,
  guide: { ...(song?.guide || {}), step: Math.max(1, Math.min(5, step)), done: false },
});

export const markGuide = (song, flag) => (
  song?.guide && !song.guide.done && !song.guide[flag]
    ? { ...song, guide: { ...song.guide, [flag]: true } }
    : song
);

export const nextStep = (song) => withGuideStep(song, Number(song?.guide?.step || 1) + 1);

export const prevStep = (song) => withGuideStep(song, Number(song?.guide?.step || 1) - 1);

export const ensureLines = (song, label, count) => {
  const sections = [...(song?.sections || [])];
  const sectionIndex = sections.findIndex((section) => section.label === label);
  const existing = sectionIndex >= 0 ? sections[sectionIndex] : { label, lines: [] };
  const lines = [...(existing.lines || [])];
  while (lines.length < count) lines.push({ text: '', source_answer_ids: [] });
  const nextSection = { ...existing, lines };
  if (sectionIndex >= 0) {
    sections[sectionIndex] = nextSection;
  } else {
    sections.push(nextSection);
    sections.sort((a, b) => SECTION_ORDER.indexOf(a.label) - SECTION_ORDER.indexOf(b.label));
  }
  return { ...song, sections };
};

export const startGuide = (song) => ({ ...song, guide: { step: 1, done: false } });

export const finishGuide = (song) => ({
  ...song,
  guide: { ...(song?.guide || {}), step: Number(song?.guide?.step || 1), done: true },
});

export const shouldOfferGuide = (songs) => !Array.isArray(songs) || songs.length === 0;
